import React from 'react';
import { DEFAULT_ICON_SIZE } from '../../constants';
import type { GoIconProps } from '../../types';

const GoThreeLinesIcon = ({ size = DEFAULT_ICON_SIZE, color = 'currentColor' }: GoIconProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 12H20" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 5H15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4 19H15" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
GoThreeLinesIcon.id = 'GoThreeLinesIcon';
GoThreeLinesIcon.displayName = 'GoThreeLinesIcon';
export default GoThreeLinesIcon;
